import type { ProviderSpecialty } from '../types';

export const HCC_SPECIALTY_MAP: Record<string, ProviderSpecialty[]> = {
  'HCC 18':  ['PCP', 'Endocrinology'],
  'HCC 19':  ['PCP', 'Endocrinology'],
  'HCC 21':  ['PCP', 'Gastroenterology'],
  'HCC 22':  ['PCP', 'Endocrinology'],
  'HCC 47':  ['PCP', 'Cardiology', 'Nephrology'],
  'HCC 51':  ['PCP', 'Neurology', 'Psychiatry'],
  'HCC 59':  ['PCP', 'Psychiatry'],
  'HCC 85':  ['PCP', 'Cardiology'],
  'HCC 87':  ['PCP', 'Cardiology', 'Pulmonology'],
  'HCC 96':  ['PCP', 'Cardiology'],
  'HCC 108': ['PCP', 'Cardiology'],
  'HCC 111': ['PCP', 'Pulmonology'],
  'HCC 137': ['PCP', 'Nephrology'],
  'HCC 138': ['PCP', 'Nephrology'],
};

export const PROVIDER_SPECIALTIES: ProviderSpecialty[] = [
  'PCP',
  'Cardiology',
  'Endocrinology',
  'Nephrology',
  'Pulmonology',
  'Psychiatry',
  'Neurology',
  'Gastroenterology',
];

export function isRelevantToSpecialty(
  hccCategory: string | null,
  specialty: ProviderSpecialty,
): boolean {
  if (!hccCategory) return false;
  const specialties = HCC_SPECIALTY_MAP[hccCategory];
  return specialties ? specialties.includes(specialty) : false;
}

export function isInScope(
  hccCategory: string | null,
  specialty: ProviderSpecialty | null,
): boolean {
  if (!specialty || specialty === 'PCP') return true;
  if (!hccCategory) return false;
  return isRelevantToSpecialty(hccCategory, specialty);
}
